import { createReducer, on } from '@ngrx/store';
import { cloneDeep } from 'lodash';

import { PropertyDetails, ReleasedConnection, ReleasedProperty } from '@core/api';
import { BasicListQueryParams, initActions, ItemUIState, ListUIState } from '@core/store';

import * as mapPageActions from '../actions/map-page.actions';
import { featureConnectionActions } from '../actions/property-management.actions';

export const featureKey = 'propertyManagement';

export interface PropertyQueryParams extends BasicListQueryParams {
  search?: string;
}

export interface PropertyManagementState extends ItemUIState<ReleasedConnection> {
  list: ListUIState<ReleasedProperty, PropertyQueryParams>;
  details: ItemUIState<PropertyDetails>;
}

export const initialState: PropertyManagementState = {
  status: 'INIT',

  list: {
    status: 'INIT',
    params: {
      page: 0,
      search: '',
    },
  },

  details: {
    status: 'INIT',
  },
};

export const reducer = createReducer<PropertyManagementState>(
  cloneDeep(initialState),
  on(initActions.appCleanup, mapPageActions.leaveMap, () => cloneDeep(initialState)),

  on(featureConnectionActions.fetchPropertyManagement, (state) => ({
    ...state,
    status: 'INIT',
  })),
  on(featureConnectionActions.fetchPropertyManagementSuccess, (state, { releasedConnection, allUsersPro }) => ({
    ...state,
    data: { ...releasedConnection, allUsersPro },
    status: 'READY',
  })),
  on(featureConnectionActions.fetchPropertyManagementFail, (state, { error }) => ({
    ...state,
    error,
    status: 'ERROR',
  })),

  on(featureConnectionActions.fetchPropertyAreasList, (state) => ({
    ...state,
    list: {
      ...state.list,
      status:
        state.list.params.page === 0 && !state.list.data?.length
          ? 'LOADING'
          : state.list.params.page === 0 && state.list.data?.length > 0
            ? 'REFRESHING'
            : 'LOADING_MORE',
    },
  })),
  on(featureConnectionActions.fetchPropertyAreasListSuccess, (state, { data }) => ({
    ...state,
    list: {
      ...state.list,
      status: 'READY',
      data: state.list.params.page === 0 ? data.data : [...state.list.data, ...data.data],
      params: {
        ...state.list.params,
        page: data.hasNext ? state.list.params.page + 1 : state.list.params.page,
      },
      more: data.hasNext,
    },
  })),
  on(featureConnectionActions.fetchPropertyAreasListFail, (state, { error }) => ({
    ...state,
    list: {
      ...state.list,
      status: 'ERROR',
      error,
    },
  })),
  on(featureConnectionActions.leaveTab, (state) => ({
    ...state,
    list: {
      ...state.list,
      params: {
        ...state.list.params,
        page: 0,
        search: '',
      },
    },
  })),
  on(featureConnectionActions.filterProperties, (state, { search }) => ({
    ...state,
    list: {
      ...state.list,
      status: 'LOADING',
      params: { ...state.list.params, search, page: 0 },
    },
  })),

  on(featureConnectionActions.fetchPropertyDetails, (state) => ({
    ...state,
    details: {
      ...state.details,
      status: 'LOADING',
    },
  })),
  on(featureConnectionActions.fetchPropertyDetailsSuccess, (state, { data }) => ({
    ...state,
    details: {
      ...state.details,
      status: 'READY',
      data,
    },
  })),
  on(featureConnectionActions.fetchPropertyDetailsFail, (state, { error }) => ({
    ...state,
    details: {
      ...state.details,
      status: 'ERROR',
      error,
    },
  }))
);
